<template>
  <div class="modal-container" @click.self="closeModal">

    <svg v-if="currentModal !== 'ModalDetail'" version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="close" @click="closeAction">
      <path d="M23 0L11.999 11.001.999 0 0 1l10.999 11.001L0 23l.999 1 11-10.999L23 24l1-1-11.001-10.999L24 1z"/>
    </svg>

    <component
      :is="currentModal"
      :currentModal="currentModal"
    ></component>

  </div>
</template>

<script>
import ModalDetail from 'components/modal/ModalDetail'
import Calendar from 'sections/Guide/Calendar'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'ModalOverlay',
  components: {
    ModalDetail,
    Calendar
  },
  computed: {
    ...mapState({
      modalType: state => state.modal.modalType,
      modalData: state => state.modal.modalData
    }),
    currentModal: function () {
      switch (this.modalType) {
        case 'detail':
          return 'ModalDetail'
        case 'calendar':
          return 'Calendar'
        default:
          return false
      }
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_CURRENT_EVENT'
    ]),
    ...mapActions([
      'closeModal'
    ]),
    closeAction: function () {
      var self = this

      // Clear current event
      if (this.modalType === 'detail') {
        setTimeout(function () {
          self.UPDATE_CURRENT_EVENT()
        }, 500)
      }

      this.closeModal()
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'uc/_variables';

  .modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 650px;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.8);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    z-index: 2147483647;
      &.active {
        opacity: 1;
        visibility: visible;
      }
  }

  .close {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 30px;
    right: 40px;
    cursor: pointer;
    fill: #fff;
  }

  @media only screen and (max-width: $breakpoint1) {
    .modal-container {
      position: absolute;
      width: 1024px;
    }
  }

  @media only screen and (max-width: $breakpoint3) and (max-height: 720px) {
    .modal-container {
      position: absolute;
      height: 100%;
      overflow: auto;
    }
  }
  @media only screen and (min-width: $breakpoint3) and (max-height: 850px) {
    .modal-container {
      display: block;
      overflow: auto;
      min-height: 0;
      padding: 50px;
    }
    /deep/ .popup-box {
      margin: 0 auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/modal/ModalOverlay.vue